```vue
<template>
	<div class="save-button-wrapper">
		<button
			type="button"
			id="save-button"
			class="b360-btn--primary save-button"
			:class="[{ disabled: disabled, success: saved }]"
			:disabled="disabled"
			@click="$emit('handle-click')"
		>
			<font-awesome-icon
				v-if="waiting"
				class="waiting-animation"
				:icon="['far', 'circle-notch']"
			/>
			<font-awesome-icon
				v-else-if="saved"
				class="success-animation"
				:icon="['far', 'check']"
			/>
			<span v-else class="button-content">Save</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'SaveButton',
	props: {
		waiting: Boolean,
		saved: Boolean,
		disabled: Boolean,
	},
};
</script>

<style lang="scss" scoped>
// @import '@/SCSS/components/buttons/_buttons.scss';
.save-button-wrapper {
	@include rem('margin-top', 25px);
	display: flex;
	justify-content: center;
	align-items: center;
	@include lg {
		justify-content: flex-end;
	}
}
.save-button {
	width: 100%;
	@include lg {
		@include rem('max-width', 100px);
	}
	&.disabled {
		background-color: $b360-color--gray__lighter;
		color: $b360-color--gray__darker-80;
		cursor: not-allowed;
	}
	&.waiting {
		@include rem(font-size, 20px);
		color: $white;
		.button-content {
			opacity: 0;
			@include rem('font-size', 20px);
			font-weight: bold;
		}
		.waiting-animation {
			top: calc(50% - 10px);
			left: calc(50% - 10px);
			@include rem('min-width', 20px);
			animation: spin 1.5s ease-in-out infinite;
			@include rem(font-size, 20px);
		}
	}
	&.success {
		@include rem(font-size, 20px);
		background-color: $success;
		color: $white;
		.button-content {
			opacity: 0;
			@include rem('font-size', 16px);
		}
		.success-animation {
			opacity: 1;
			top: calc(50% - 10px);
			left: calc(50% - 10px);
			@include rem('min-width', 20px);
			animation: scaleIn 0.6s cubic-bezier(0.28, 0.84, 0.42, 1);
		}
	}
	&.disabled.success {
		background-color: $success;
		color: $white;
		cursor: not-allowed;
	}
}
</style>
